import Cluster, { ClusterAPIResponse } from "@/classes/cluster";
import { DATA_API_SERVICE } from "@/appConfig";
import sortBy from "lodash/sortBy";
import API from "@/api/api";
import apolloClient from "@/api/charge";
import { gql } from "@apollo/client/core";

async function findAll() {
  const res = await apolloClient.query({
    query: gql`
      query Clusters {
        clusters {
          id
          pKey: propertyId
          cId: name
          cMaxAmps: maxAmps
          panelKey: panelId
        }
      }
    `
  });
  const mappedClusters =
    res.data?.clusters?.map(cluster => {
      return new Cluster(cluster);
    }) || [];
  return sortBy(mappedClusters, cluster => cluster.cId);
}

async function getCluster(clusterId: string) {
  const res = await apolloClient.query({
    query: gql`
      query Cluster($id: ID!) {
        cluster(id: $id) {
          id
          pKey: propertyId
          cId: name
          cMaxAmps: maxAmps
          panelKey: panelId
        }
      }
    `,
    variables: {
      id: clusterId
    }
  });
  return Cluster.fromAPI(res.data?.cluster);
}

async function getClustersForProperty(propertyId: string) {
  const results = await API.get<ClusterAPIResponse[]>(`${DATA_API_SERVICE}/cluster/property/${propertyId}`);
  const mappedClusters = results.data.map(cluster => {
    return new Cluster(cluster);
  });
  return sortBy(mappedClusters, cluster => cluster.cId);
}

async function create(cluster: Cluster) {
  await API.post(`${DATA_API_SERVICE}/cluster`, {
    pKey: cluster.pKey,
    cId: cluster.cId,
    cMaxAmps: cluster.cMaxAmps,
    panelKey: cluster.panelKey
  });
  return true;
}

async function update(cluster: Cluster) {
  await API.put(`${DATA_API_SERVICE}/cluster/${cluster.id}`, {
    pKey: cluster.pKey,
    cId: cluster.cId,
    cMaxAmps: cluster.cMaxAmps,
    panelKey: cluster.panelKey
  });
  return true;
}

const APICluster = {
  create,
  findAll,
  getCluster,
  getClustersForProperty,
  update
};

export default APICluster;
